<ecmo-page [pageTitle]="'error.title' | translate" [greyBackground]='true'>
  <div class='container'>
    <div class='column'>
      <div class='row column no-gap'>
        <p [innerHTML]="'error.' + status | translate"></p>
      </div>
      <div class='row'>
        <button mat-stroked-button class='no-border'
                [routerLink]="['..']">{{ 'global.close' | translate }}</button>
      </div>
    </div>
  </div>

  <ecmo-footer></ecmo-footer>
</ecmo-page>
